import FullLayout from '@/modules/core/layouts/FullLayout.vue';
import StripeVision from '@/modules/dashboards/stripe/StripeVision.vue';
import RetornoAssinatura from '@/modules/dashboards/stripe/components/RetornoAssinatura.vue';
export default {
  path: '/dashboards',
  component: FullLayout,
  meta: { requiresAuth: true },
  children: [
    { name: 'assinar', path: 'assinar', component: StripeVision },
    { props: true, name: 'assinaturaConcluida', path: 'assinar/:sessionId', component: RetornoAssinatura },
  ],
};
